import { ArrowDown } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowDown12Line = createIcon(ArrowDown, 12, "Line");
export const IconArrowDown16Line = createIcon(ArrowDown, 16, "Line");
export const IconArrowDown20Line = createIcon(ArrowDown, 20, "Line");
export const IconArrowDown24Line = createIcon(ArrowDown, 24, "Line");
export const IconArrowDown32Line = createIcon(ArrowDown, 32, "Line");
export const IconArrowDown48Line = createIcon(ArrowDown, 48, "Line");
export const IconArrowDown64Line = createIcon(ArrowDown, 64, "Line");
